export default __webpack_public_path__ + "static/media/celular-pet.73093590.png";